module.exports = __webpack_public_path__ + "static/media/Reset Shared Coordinates.834ea847.png";